import { Component, Input, OnInit, TemplateRef, Output, EventEmitter } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';
import { NbDialogService, NbDialogRef } from '@nebular/theme';
import { PeticionesHttpBackEndService } from '../../@core/mock/peticiones-http-backend.service';

import { HttpClient } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilidadesService } from '../../@core/utils/utilidades.service';

@Component({
  templateUrl: './AccionDescargarEntrada.component.html'
})
export class AccionDescargarEntradaComponent implements ViewCell, OnInit {

  renderValue: string;
  activeModal: any;
  resultadoRequest: any;
  tipo:any;

  @Input() value: string | number;
  @Input() rowData: any;
  esMoodle:any;

  constructor(private dialogService: NbDialogService, private modalService: NgbModal, private _http: PeticionesHttpBackEndService,private utilidades: UtilidadesService) {
    
  }

  ngOnInit() {
    this.esMoodle = this.rowData.EsMoodle == 0 ? false : true;
   
  }

  descargarEntrada(){
    this._http.postGeneralConParametro("v1/generarEntrada",{Data:this.rowData}).subscribe( 
      result => {
        this.resultadoRequest = result;
        if(this.resultadoRequest.Code != 200){
          this.utilidades.notificationWarning("Error","Ha ocurrido un error al descargar la entrada","top-left");
        }else{
          const win = window.open("","_blank");
          let html = '';
          let cadena = "";
          this.tipo = "application/pdf";
            cadena =  this.tipo;
          const linkSource = 'data:'+cadena+';base64,' + this.resultadoRequest.Archivo;
          const downloadLink = document.createElement("a");
          const fileName = "Entrada - "+this.rowData.Nombre;
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();

          setTimeout(() => {
            win.document.write(html);
          }, 0);
        }
      },
      error => {
        this.utilidades.notificationWarning("Error",""+"Ocurrio un problema en el servidor"+"","top-left");
      }
    );

    
  }


}
